export default "__VITE_ASSET__CXQbhRWt__"